var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('purchase-gallery-providers-view',{attrs:{"items":_vm.items,"loading":_vm.loading,"enable-scroll":_vm.enableScroll},on:{"next":_vm.getNextPage}})}
var staticRenderFns = []

export { render, staticRenderFns }